import axios from "../api";
/** Records on the account that the user has seen or used a feature. */
export const postUsedFeature = async (feature) => {
    const res = await axios.post("/users/used-features", { feature });
    return res.data;
};
//# sourceMappingURL=postUsedFeature.js.map